export class KioskStateMenuItem {
  KioskToken: string = '';
  KioskName: string = '';
  State: string = 'never';
  GroupId: string = '';
  GroupName: string = '';
  ClientInitiatedDisconnect: boolean = false;
}
